import React from 'react';

const TextWatermarkPanel = () => {
  return (
    <>
    </>
  );
};

export default TextWatermarkPanel;